import { fun_PostAction, fun_Download } from "@/api/index";
import PrintDialog from "../../components/PrintDialog/index.vue";

// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 判断是否从工作台进入
      workbenchMenu: null,
      // 工作台状态
      workbenchState: false,
      // 列表loading状态
      loading: false,
      // 表头按钮组
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        },
        {
          name: "撤回",
          type: "primary",
          icon: "edit"
        }
      ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        regulators: null, // 招标监管部门
        announcementId: null, // 招标公告编号
        registrationId: null, // 招标登记编号
        tenderPrjName: null, // 招标项目名称
        prequalificationStartDate: null, // 公示开始日期
        prequalificationEndDate: null, // 公示结束日期
        drawTime: null // 随机抽签时间
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "招标项目名称：",
          value: "tenderPrjName",
          placeholder: "请输入"
        },
        {
          type: "select",
          label: "行政监督部门：",
          value: "regulators",
          placeholder: "请选择",
          disabled: false,
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201510311952460006"
          }
        },
        {
          type: "date",
          label: "公示开始日期：",
          dateType: "date",
          value: "prequalificationStartDate",
          placeholder: "请输入",
          valueFormat: "yyyy-MM-dd"
        },
        {
          type: "date",
          label: "公示结束日期：",
          dateType: "date",
          value: "prequalificationEndDate",
          placeholder: "请输入",
          valueFormat: "yyyy-MM-dd"
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "招标项目名称",
          prop: "tenderPrjName",
          width: "300",
          isShow: true,
          fixed: true
        },
        {
          label: "状态",
          slotName: "state",
          width: "110",
          fixed: true
        },
        {
          label: "公示表",
          slotName: "print",
          width: "130",
          fixed: true
        },
        {
          label: "招标组织形式",
          prop: "tenderMethodFlag",
          width: "120",
          fixed: true
        },
        {
          label: "报告状态",
          slotName: "reportState",
          width: "110",
          fixed: true
        },
        {
          label: "预审报告",
          slotName: "reportPrint",
          width: "130",
          fixed: true
        },
        {
          label: "资格预审单位",
          prop: "prequalificationCorpName",
          width: "250"
        },
        {
          label: "招标投标监管部门",
          prop: "regulatorsName",
          width: "280"
        },
        {
          label: "预审公示开始时间",
          prop: "prequalificationStartDate",
          width: "180"
        },
        {
          label: "预审公示结束时间",
          prop: "prequalificationEndDate",
          width: "180"
        }
      ],
      // 表格数据
      tableData: [],
      multipleSelection: [], // 勾选数组
      userFlag: sessionStorage.getItem("userFlag"), // 用户标识
      // 温馨提示
      tipList: [
        /* {
           type: "text",
           text:
             "（1）资格预审由招标人/招标代理机构自行组织，预审结束后，由组织方将资格预审结果（包括随机抽签结果）录入到本平台。"
         },
         {
           type: "text",
           text:
             "（2）预审结果公示截止后，由招标人/招标代理机构将资格预审评审小组成员名单和资格预审评审程序和内容录入到本平台。"
         },
         {
           type: "text",
           text: "（3）资格预审结果提交后，资格预审结果将向全社会公示。"
         },
         {
           type: "text",
           text:
             "（4）新增：点击“添加”；修改：勾选对应项目，点击“修改”；删除：勾选对应项目，点击“删除”。"
         },
         {
           type: "text",
           text:
             "（5）资格预审报告录入完成并通过后，请招标人/招标代理机构在“发送资格预审通知书”中选择项目，进行资格预审通知书发送。"
         },
         {
           type: "text",
           text:
             "（6）当状态为“招标人确认中”时，招标人请点击项目名称进入详情后进行操作。"
         },
         {
           type: "AdobeReader"
         }*/
      ]
    };
  },
  // 注册组件
  components: {
    PrintDialog // 打印
  },
  // 模板编译前
  created() {
    // 获取数据
    this.workbenchMenu = sessionStorage.getItem("workbenchMenu") ? sessionStorage.getItem("workbenchMenu") : null;
  },
  // 模板编译完成
  mounted() {
    // 如果用户标识是工作人员或者监管人员
    if (this.userFlag === "工作人员" || this.userFlag === "监管人员" || this.userFlag === "分包合同监管人员") {
      // 清空表头
      this.btnList = [];
    }
    // 默认打开项目评审列表
    this.fun_GetList();
    // 获取工作台状态
    this.fun_GetWorkbenchState();
  },

  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/prequalification/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 获取工作台状态
     */
    fun_GetWorkbenchState() {
      // 请求，获取结果集
      fun_PostAction("/prequalification/getWorkbenchState", {}).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 回显table
          this.workbenchState = data.workbenchState;
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      this.form[i] = e;
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 付翔
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          this.fun_Add();
          break;
        case "修改":
          this.fun_Edit();
          break;
        case "删除":
          this.fun_Del();
          break;
        case "撤回":
          this.fun_Revoke();
          break;
        default:
      }
    },
    /**
     * 查看详情
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_Details(e) {
      // 甲方确认标志
      let tenderSigFlag = "";
      // 甲方确认状态不为空
      if (e.val.tenderSignedState != "" && e.val.tenderSignedState != null) {
        // 设置为是
        tenderSigFlag = "1";
      }
      // 跳转详情页面
      this.$router.push({
        path: "/tbPrequalificationDetail",
        query: {
          id: e.val.id,
          isTenderSignature: tenderSigFlag,
          type: "details"
        }
      });
    },
    /**
     * 点击新增按钮
     */
    fun_Add() {
      // 跳转详情页面
      this.$router.push({
        path: "/tbPrequalificationDetail",
        query: { type: "insert" }
      });
    },
    /**
     * 点击修改按钮
     */
    fun_Edit() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 如果勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        } else {
          // 如果是自行招标
          if (this.multipleSelection[0].tenderMethod != "1") {
            // 则验证若是招标人则不能修改操作
            if (this.multipleSelection[0].tenderCorpFlag == "01") {
              // 提示，并清除选中数据
              this.$alert(
                "该项目为委托招标请直接点击项目进入详情进行查看，不能修改项目数据。",
                "warning"
              ).then(() => {
                // 清除选中数据
                this.$refs.list.$refs.multipleTable.clearSelection();
              });
              return false;
            }
          }
          // 如果是提交状态
          if (this.multipleSelection[0].state == "tj") {
            // 设置状态名称
            let stateName = "提交";
            // 招标人签章确认编号不为空
            if (
              this.multipleSelection[0].tenderSignedId != "" &&
              this.multipleSelection[0].tenderSignedId != null
            ) {
              // 招标人签章状态为提交
              if (this.multipleSelection[0].tenderSignedId == "tj") {
                // 设置状态名称
                stateName = "招标人确认中";
              }
            }
            // 提示，并清除选中数据
            this.$alert(
              "该项目当前状态为“" + stateName + "”，不能修改！",
              "warning"
            ).then(() => {
              // 清除选中数据
              this.$refs.list.$refs.multipleTable.clearSelection();
            });
            return false;
          }
          // 状态为通过
          if (this.multipleSelection[0].state == "tg") {
            // 提示，并清除选中数据
            this.$alert(
              "该项目当前状态为“通过”，不能修改！",
              "warning"
            ).then(() => {
              // 清除选中数据
              this.$refs.list.$refs.multipleTable.clearSelection();
            });
            return false;
          }
          // 如果预审报告状态为通过
          // if (this.multipleSelection[0].reportState == "01") {
          //   // 提示，并清除选中数据
          //   this.$alert(
          //     "该项目的资格预审报告已通过，不能修改！",
          //     "warning"
          //   ).then(() => {
          //     // 清除选中数据
          //     this.$refs.list.$refs.multipleTable.clearSelection();
          //   });
          //   return false;
          // }
          // 跳转详情页面
          this.$router.push({
            path: "/tbPrequalificationDetail",
            query: { id: this.multipleSelection[0].id, type: "update" }
          });
        }
      }
    },
    /**
     * 删除
     */
    fun_Del() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 主键数组
        let keys = [];
        // 招标公告主键集合
        let announcementIds = [];
        // 遍历勾选
        for (const index in this.multipleSelection) {
          // 如果是自行招标
          if (this.multipleSelection[index].tenderMethod != "1") {
            // 则验证若是招标人则不能修改操作
            if (this.multipleSelection[index].tenderCorpFlag == "01") {
              // 提示，并清除选中数据
              this.$alert(
                "该项目为委托招标请直接点击项目进入详情进行查看，不能修改项目数据。",
                "warning"
              ).then(() => {
                // 清除选中数据
                this.$refs.list.$refs.multipleTable.clearSelection();
              });
              return false;
            }
          }
          // 如果是提交或者通过状态
          if (
            this.multipleSelection[index].state == "tj" ||
            this.multipleSelection[index].state == "tg"
          ) {
            // 提示，并清除选中数据
            this.$alert(
              "该项目信息已通过或者已提交，无法进行删除或修改操作！",
              "warning"
            ).then(() => {
              // 清除选中数据
              this.$refs.list.$refs.multipleTable.clearSelection();
            });
            return false;
          }
          // 赋值主键集合
          keys[index] = this.multipleSelection[index].id;
          // 赋值招标公告主键集合
          announcementIds[index] = this.multipleSelection[index].announcementId;
        }
        // 弹出询问confirm
        this.$confirm("是否确定删除选中数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 请求，获取结果集
          fun_PostAction("/prequalification/delete", {
            keys: keys,
            announcementIds: announcementIds
          }).then(res => {
            // 解构res.data
            const { msg } = res.data;
            // 操作成功
            this.$message.success(msg);
            // 获取一览表格数据
            this.fun_GetList();
          });
        });
      }
      // 如果未进行勾选
      else {
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
    /**
     * 撤回
     */
    fun_Revoke() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 如果勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        } else {
          // 如果是自行招标
          if (this.multipleSelection[0].tenderMethod != "1") {
            // 则验证若是招标人则不能修改操作
            if (this.multipleSelection[0].tenderCorpFlag == "01") {
              // 提示，并清除选中数据
              this.$alert(
                "该项目为委托招标请直接点击项目进入详情进行查看，不能修改项目数据。",
                "warning"
              ).then(() => {
                // 清除选中数据
                this.$refs.list.$refs.multipleTable.clearSelection();
              });
              return false;
            }
          }
          // 资格预审结果未核验通过，不能撤回
          if (
            this.multipleSelection[0].state != "tg" &&
            (this.multipleSelection[0].reportState == "" ||
              this.multipleSelection[0].reportState == null)
          ) {
            // 提示，并清除选中数据
            this.$alert(
              "该项目的资格预审结果未通过，不能撤回！",
              "warning"
            ).then(() => {
              // 清除选中数据
              this.$refs.list.$refs.multipleTable.clearSelection();
            });
            return false;
          }
          // 请求，获取结果集
          fun_PostAction("/prequalification/validateOpenBidRecord", {
            registrationId: this.multipleSelection[0].registrationId
          }).then(res => {
            // 解构res.data
            const { result, data } = res.data;
            // 判断请求是否成功
            if (result) {
              // 提示，并清除选中数据
              this.$alert("该项目已开标，不能撤回！", "warning").then(() => {
                // 清除选中数据
                this.$refs.list.$refs.multipleTable.clearSelection();
              });
              return false;
            }else{
              // 跳转详情页面
              this.$router.push({
                path: "/tbPrequalificationDetail",
                query: { id: this.multipleSelection[0].id, type: "revoke" }
              });
            }
          });
        }
      }
      // 如果未进行勾选
      else {
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
    /**
     * 资格预审公告打印
     */
    fun_Print(data) {
      // 打开弹窗
      this.$refs.printDialog.dialogVisible = true;
      // 主键
      this.$refs.printDialog.id = data.id;
      // 编号
      this.$refs.printDialog.everyIds = data.announcementId;
      // ids
      this.$refs.printDialog.data = data.id;
      // ids
      this.$refs.printDialog.agencyId = data.agencyId;
      // 权限编号
      this.$refs.printDialog.operationNum = "201606061508000010";
      // flag
      this.$refs.printDialog.flag = "notice";
      // 招标人且是委托招标
      if (sessionStorage.getItem("loginType") == "201904241041160002" && data.tenderMethod === '2') {
        // 不显示加盖签章
        this.$refs.printDialog.showBtn = false;
      }
    },
    /**
     * 资格预审结果报告打印
     */
    fun_ReportPrint(data) {
      // 打开弹窗
      this.$refs.printDialog.dialogVisible = true;
      // 主键
      this.$refs.printDialog.id = data.id;
      // 编号
      this.$refs.printDialog.everyIds = data.announcementId;
      // ids
      this.$refs.printDialog.data = data.id;
      // ids
      this.$refs.printDialog.agencyId = data.agencyId;
      // 权限编号
      this.$refs.printDialog.operationNum = "201606061508000010";
      // flag
      this.$refs.printDialog.flag = "result";
      // 招标人且是委托招标
      if (sessionStorage.getItem("loginType") == "201904241041160002" && data.tenderMethod === '2') {
        // 不显示加盖签章
        this.$refs.printDialog.showBtn = false;
      }
    },

    /**
     * 打印的方法
     */
    fun_DialogPrint(id, agency, tender, agencyRecords, bidder, lock, recordNumber, flag) {
      let controller;
      if (flag === "notice") {
        controller = "prequalificationNoticePrint";
      } else if (flag === "result") {
        controller = "prequalificationResultPrint";
      }
      // 发起请求
      fun_Download("/dialogPrint", {
        controller: controller,
        id: id,
        agency: agency,
        tender: tender,
        agencyRecords: agencyRecords,
        lock: lock,
        recordNumber: recordNumber
      }).then(res => {
        const data = new Blob([res.data], { type: "application/pdf" });
        const reader = new FileReader();
        // 如果文件大小等于0
        if(data.size == 0){
          this.$message.success("文件生成中！");
        }else{
          //
          this.$refs.printDialog.isShow = true;
          // 读取文件
          reader.readAsText(data);
          // 触发onload事件
          reader.onload = () => {
            // json格式数据转换成对象
            if (reader.result.indexOf("result") > -1) {
              const result = JSON.parse(reader.result);
              if (result.result == false) {
                this.$message.error(result.msg);
              }
            } else {
              this.$refs.printDialog.pdfUrl =
                  "./static/pdf/web/viewer.html?file=" +
                  encodeURIComponent(URL.createObjectURL(data));
            }
          };
        }
      });
    }
  }
};
